import * as React from 'react';
import PolicyTipsPeek from '../components/PolicyTipsPeek';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import strings from 'owa-strings/owa-common-strings';
import { InfoBarCalloutAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

const POLICY_TIPS_PEEK_MAX_WIDTH = 320;

export function createPolicyTipsPeekInfoBarAction(
    policyTipsViewState: PolicyTipsViewState
): InfoBarCalloutAction {
    return {
        text: strings.policyTipsLearnMoreLink,
        calloutContent: <PolicyTipsPeek viewState={policyTipsViewState} />,
        maxWidth: POLICY_TIPS_PEEK_MAX_WIDTH,
    };
}
